module.exports = __webpack_public_path__ + "img/social-shorts.5a03dd62.jpg";